import { render, staticRenderFns } from "./BattleRoyaleResults.vue?vue&type=template&id=769983b9&"
import script from "./BattleRoyaleResults.vue?vue&type=script&lang=js&"
export * from "./BattleRoyaleResults.vue?vue&type=script&lang=js&"
import style0 from "./BattleRoyaleResults.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports